import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import decisionValues from "../../decision.json";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import { FaCheck } from 'react-icons/fa';
import Api from '../../../api/api';
const DecisionInputes = (props) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [symbols, setSymbols] = useState([]);
    // const [props.mainIndex, setprops.mainIndex] = useState('');
    const options = decisionValues.fieldData[props.label.split(",")[1]];

    useEffect(() => {
        const fetchData = async () => {
            try {
                // const apiUrl = 'https://0fajarpurnama0.github.io/assets/json/quote.json';
                const apiUrl = 'https://FLOWTICKR.s3.ap-south-1.amazonaws.com/strategy_jsons/openPosition.json';
                const response = await fetch(apiUrl);
                const jsonData = await response.json();
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        // fetchData();
    }, []);

    const getSymbols = async () => {
        try {
            const res = await Api.symbols(searchString);
            setSymbols(JSON.parse(res.search_string))

        } catch (error) {
            console.error("Error fetching symbols:", error);
        }
    };

    let filteredOptions = [];

    filteredOptions = (props.label.split(",")[1] !== "number" && props.label.split(",")[1] !== "dttm" && props.label.split(",")[1] !== "time" && props.label.split(",")[1] !== "text" && props.label.split(",")[1] !== "position") ? options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
    ) : [];
    if (props.label.split(",")[1] === "position") {
        let result = [];
        props.openPositions.forEach(item => {
            let pos = item["POS"];
            result.push(`POSITION${pos}`);
        });
        filteredOptions = result;
    } else if (props.label.split(",")[1] === "label") {
        let result = [];
        props.tagNames.forEach(item => {
            result.push(item);
        });
        filteredOptions = result;
    }

    const updateInput = (val, type) => {
        let preData = props.decisionValue;
        if (type == "date") {
            setSelectedDate(val);
            preData[props.mainIndex][props.index] = moment(val).format("MM-DD-YYYY HH:mm");
        } else if (type == "time") {
            setSelectedTime(val);
            preData[props.mainIndex][props.index] = moment(val).format("HH:mm");
        } else {
            preData[props.mainIndex][props.index] = val;
        }
        props.setDecisionValue(preData);
        props.setIsInputUpdate(!props.isInputUpdate)
        if (props.activeTab < Object.keys(props.decisionValue[Object.keys(props.decisionValue)[0]]).length - 1 && type !== "number" && type !== "text") props.setActiveTab(parseInt(props.activeTab) + 1);
        // setIsValueUpdate(!isValueUpdate);
    }

    const handleTickClick = () => {
        if (props.activeTab < Object.keys(props.decisionValue[Object.keys(props.decisionValue)[0]]).length - 1) props.setActiveTab(parseInt(props.activeTab) + 1);
    }


    const handleSelectChange = (event) => {
        const { options } = event.target;
        const selectedValues = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selectedValues.push(options[i].value);
            }
        }
        let preData = props.decisionValue;
        preData[props.mainIndex][props.index] = event.target.value;
        props.setDecisionValue(preData);
    };

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState();

    const [searchString, setSearchString] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);

    const handleSearchInput = (value) => {
        setSearchString(value);
    };

    useEffect(() => {
        if (searchString.length >= 3) {
            const delayDebounce = setTimeout(() => {
                getSymbols()
            }, 300);

            return () => clearTimeout(delayDebounce);
        } else if (searchString.length === 0) {
            setSymbols([])
        }
    }, [searchString]);



    const filteredSymbos = symbols?.filter(option =>
        option.z_symbol?.toLowerCase().includes(searchString.toLowerCase())
    ).sort((a, b) => {
        const searchLower = searchString.toLowerCase();
        const aName = a.z_symbol?.toLowerCase() || '';
        const bName = b.z_symbol?.toLowerCase() || '';
        
        const aStartsWith = aName.startsWith(searchLower);
        const bStartsWith = bName.startsWith(searchLower);
        
        // If one starts with search string and other doesn't, prioritize the one that starts with it
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;
        
        // If both start with or both don't start with, sort alphabetically
        return aName.localeCompare(bName);
    });

    const updateSymbols = (value) => {
        setShowDropdown(false);
    };

    return (
        <>
            <span className='mt-2 pt-2 decition-input-wrapper'>
                <span className={(props.selectedInput?.split(",")[0] == props.index) ? 'show-' : 'hide-'}>
                    <Form.Label sm={2} className='hide font-weight-bold text-left' style={{ fontWeight: '600', textTransform: "capitalize", position: "absolute", top: "25px" }}>
                        {props.label?.split(",")[0]}
                    </Form.Label>
                    {props.type == 'number' &&
                        <Form.Group className="position-relative">
                            {/* Input field */}
                            <Form.Control
                                type="number"
                                value={props.decisionValue[props.mainIndex][props.index]}
                                onChange={e => updateInput(e.target.value, "number")}
                                placeholder="Enter a number"
                            />

                            {/* Tick Icon */}
                            <div
                                onClick={handleTickClick}
                                className="position-absolute top-50 end-0 translate-middle-y pe-3"
                                style={{ cursor: 'pointer' }}
                            >
                                <FaCheck size={20} style={{ padding: "3px", marginRight: "5px", border: "1px solid #444", background: "#fff", color: "#28a745", borderRadius: "100%" }} />
                            </div>
                        </Form.Group>}
                </span>
                <span className={(props.selectedInput?.split(",")[0] == props.index) ? 'show-' : 'hide-'}>
                    {props.type === 'search' && <><input
                        type="text"
                        placeholder="Search"
                        size="sm"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{
                            padding: '3px',
                            borderRadius: '5px',
                            border: '1px solid #EAEAEA',
                            width: '30%', display: 'none'
                        }}
                    />
                        <select className='form-control' onChange={e => updateInput(e.target.value)} value={props.decisionValue[props.mainIndex][props.index]}>
                            {filteredOptions.map((option, index) => (
                                <option key={index} value={option} style={{
                                    textTransform: "lowercase"
                                }}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </>
                    }
                </span>
                <span className={(props.selectedInput?.split(",")[0] == props.index) ? 'show-' : 'hide-'}>
                    {props.type == 'multiselect' && <Form.Select
                        multiple
                        value={props.decisionValue[props.mainIndex][props.index]}
                        onChange={handleSelectChange}
                    >
                        {filteredOptions.map((option, index) => (
                            <option key={index} value={option}>
                                {option}
                            </option>
                        ))}
                    </Form.Select>}
                </span>

                <span className={(props.selectedInput?.split(",")[0] == props.index) ? 'show-' : 'hide-'}>
                    {props.type == 'select' && props.label.split(",")[0] !== 'symbol' && props.label.split(",")[0] !== 'Stock' && <Form.Select
                        value={props.decisionValue[props.mainIndex][props.index]}
                        onChange={e => updateInput(e.target.value)}

                    >
                        <option key="0" value="">
                            Select a vaue
                        </option>
                        {filteredOptions.map((option, index) => (
                            <option key={index} value={option}>
                                {option}
                            </option>
                        ))}
                    </Form.Select>}
                </span>

                <span className={(props.selectedInput?.split(",")[0] === props.index) ? 'show-' : 'hide-'}>
                    {props.type === 'select' && (props.label.split(",")[0] === 'symbol' || props.label.split(",")[0] === 'Stock') && (
                        <div className="custom-dropdown">
                            <Form.Control
                                type="text"
                                placeholder="Search..."
                                value={searchString}
                                onChange={e => handleSearchInput(e.target.value)}
                                onFocus={() => setShowDropdown(true)}
                            />
                            {showDropdown && (
                                <div className="dropdown-options symbol-dropdown-wrapper">
                                    {/* <div className="option" onClick={() => updateSymbols('')}>
                                        Select a value
                                    </div> */}
                                    {filteredSymbos.map((option, index) => (
                                        <div
                                            key={index}
                                            className="option"
                                            onClick={() => updateInput(option.z_symbol)}
                                        >
                                            {option.z_symbol}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </span>


                <span className={(props.selectedInput?.split(",")[0] == props.index) ? 'show-' : 'hide-'}>
                    {props.type == 'dttm' && <span className='date-time-picker'>
                        <DatePicker
                            selected={selectedDate}
                            // onChange={handleChange}
                            show-TimeSelect
                            timeIntervals={5}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            className='form-control date-picker'
                            onChange={e => updateInput(e, "date")}
                        />
                    </span>}
                </span>
                <span className={(props.selectedInput?.split(",")[0] == props.index) ? 'show-' : 'hide-'}>
                    {props.type == 'time' && <span className='date-time-picker'>
                        <TimePicker
                            show-Hour
                            show-Second={false}
                            defaultValue={selectedTime}
                            onChange={e => updateInput(e, "time")}
                        />
                    </span>}
                </span>
                <span className={(props.selectedInput?.split(",")[0] == props.index) ? 'show-' : 'hide-'}>
                    {props.type == 'text' && <span>
                        <input type='text' className='form-control' onChange={(e) => updateInput(e.target.value)} />
                    </span>}
                </span>
            </span>
        </>
    );
};

export default DecisionInputes;
